import React from "react";
import styled from "styled-components";

const HomeBrand = ({ scale }) => {
  return (
    <Brand 
      id="Group_14"
      data-name="Group 14"
      xmlns="http://www.w3.org/2000/svg"
      width="108.848"
      height="108.849"
      viewBox="0 0 108.848 108.849"
      scale={scale}
    >
      <rect
        id="Rectangle_14"
        data-name="Rectangle 14"
        width="20.288"
        height="20.288"
        transform="translate(11.081 54.425) rotate(-45.001)"
        fill="none"
      />
      <rect
        id="Rectangle_15"
        data-name="Rectangle 15"
        width="20.288"
        height="20.288"
        transform="translate(40.079 25.426) rotate(-45)"
        fill="none"
      />
      <rect
        id="Rectangle_16"
        data-name="Rectangle 16"
        width="20.288"
        height="20.288"
        transform="translate(40.079 83.422) rotate(-45.001)"
        fill="none"
      />
      <rect
        id="Rectangle_17"
        data-name="Rectangle 17"
        width="20.288"
        height="20.288"
        transform="translate(69.077 54.424) rotate(-45.001)"
        fill="none"
      />
      <rect
        id="Rectangle_18"
        data-name="Rectangle 18"
        width="20.288"
        height="7.835"
        transform="translate(63.536 48.884) rotate(-45.001)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_19"
        data-name="Rectangle 19"
        width="20.288"
        height="7.835"
        transform="translate(34.538 77.882) rotate(-44.999)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_20"
        data-name="Rectangle 20"
        width="20.288"
        height="7.835"
        transform="translate(54.424 39.772) rotate(-45.001)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_21"
        data-name="Rectangle 21"
        width="20.288"
        height="7.835"
        transform="translate(25.426 68.77) rotate(-45)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_22"
        data-name="Rectangle 22"
        width="7.835"
        height="20.288"
        transform="translate(25.426 40.079) rotate(-45)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_23"
        data-name="Rectangle 23"
        width="7.835"
        height="20.288"
        transform="translate(34.538 30.967) rotate(-45)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_24"
        data-name="Rectangle 24"
        width="7.835"
        height="20.287"
        transform="translate(63.536 59.965) rotate(-45)"
        fill="#f06161"
      />
      <rect
        id="Rectangle_25"
        data-name="Rectangle 25"
        width="7.835"
        height="20.287"
        transform="translate(54.424 69.077) rotate(-45)"
        fill="#f06161"
      />
      <path
        id="Path_304"
        data-name="Path 304"
        d="M510.167,528.318l-5.54-5.54-14.346,14.346-14.346-14.346-5.54,5.54L490.282,548.2Z"
        transform="translate(-435.858 -439.356)"
        fill="#f06161"
        opacity="0.467"
      />
      <path
        id="Path_305"
        data-name="Path 305"
        d="M434.649,441.738l-5.54-5.54-19.886,19.886,19.886,19.886,5.54-5.54L420.3,456.083Z"
        transform="translate(-409.223 -401.659)"
        fill="#f06161"
        opacity="0.467"
      />
      <path
        id="Path_306"
        data-name="Path 306"
        d="M562.517,436.2l-5.54,5.54,14.346,14.346-14.346,14.345,5.54,5.54L582.4,456.083Z"
        transform="translate(-473.554 -401.659)"
        fill="#f06161"
        opacity="0.467"
      />
      <path
        id="Path_307"
        data-name="Path 307"
        d="M504.627,400.451l5.54-5.54-19.886-19.886L470.4,394.91l5.54,5.54,14.346-14.346Z"
        transform="translate(-435.858 -375.024)"
        fill="#f06161"
        opacity="0.467"
      />
    </Brand>
  );
};

const Brand = styled.svg`
  transform: scaleX(0.75) scaleY(${(props) => props.scale}) translateY(-1.5vh);
  transition: transform 300ms;
  will-change: transform;
  display : block;
  align-self : center;
  height : 8vh;

  @media screen and (orientation: portrait) {
    transform: scaleX(1.1) scaleY(${(props) => props.scale});
  }
`;

export default HomeBrand;
